import React from "react";
import PropTypes from "prop-types";

interface GallaboxBadgesGrayProps {
    ArabicText?: string;
}

const GallaboxBadgesGray: React.FC<GallaboxBadgesGrayProps> = ({ ArabicText }) => {
    const smallBadges = ["o1", "o2", "big-badge", "o3", "o4", "b1", "b2", "p1", "p2", "p3"];
    const smallBadgesMob = ["big-badge", "o1", "o2", "o3", "o4", "b1", "b2", "p1", "p2", "p3"];

    return (
        <section className="gallabox-badges-gray cursor-pointer" onClick={() => window.open("https://www.g2.com/products/gallabox/reviews")}>
            <h2 className="text-center mb-10 text-white">{ArabicText || "Customers love us"}</h2>
            <div className="flex flex-wrap md:flex-nowrap max-w-6xl mx-auto justify-center items-center gap-x-14 gap-y-10">
                <div className="flex flex-wrap small-badges justify-center hidden md:flex items-start">
                    {smallBadges.map((img) => (
                        <img key={img} src={`/gb-badges-gray/${img}.svg`} alt={`${img} badge image`} />
                    ))}
                </div>
                <div className="flex flex-wrap small-badges justify-center block md:hidden">
                    {smallBadgesMob.map((img) => (
                        <img key={img} src={`/gb-badges-gray/${img}.svg`} alt={`${img} badge image`} />
                    ))}
                </div>
            </div>
        </section>
    );
};

GallaboxBadgesGray.propTypes = {
    ArabicText: PropTypes.string,
};

export default GallaboxBadgesGray;
